import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute,NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { getLocalJSON, isValidStored, purgeCorruptedStorage } from './_helpers/storage.util';
declare let $: any;
declare let gtag: Function;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'greatr';
  public LoginDetail: any = [];
  public loginTrue: boolean = false;
  public currentUrl:any ='';
  public loading:boolean = false;

  constructor(private translate: TranslateService,public router: Router, private service: GlobalService) {
    purgeCorruptedStorage();
    this.translate.use('en');
    if(!localStorage.getItem('grw_materData')){
      this.getAllMasterData();
    }
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-P2XHNGMH5N',{
          'page_path': event.urlAfterRedirects
        });
      }
    });
  }

  changeRoute() { 
    var mm:any =(this.router.url).split('/');
    this.currentUrl ='/'+ mm[1];
    
    if(!localStorage.getItem('grw_materData')){
      this.getAllMasterData();
    }  
    if(this.currentUrl == '/dashboard' || this.currentUrl == '/demo-dashboard' || this.currentUrl == '/singles' || this.currentUrl == '/search'  ){
      localStorage.setItem("grw_serchView" ,'1')
    } else {
      localStorage.setItem("grw_serchView" ,'0')
    }
    if (isValidStored("grw_login")) {
      this.LoginDetail = getLocalJSON("grw_login");
      this.service.setSubject(this.LoginDetail);
    }
    if(this.currentUrl == '/forgot-password' || this.currentUrl == '/signin' || this.currentUrl == '/'  || this.currentUrl == '/signup' || this.currentUrl == '/reset-password' || this.currentUrl == '/verify-email'   || this.currentUrl == '/verify-email-mobile' || this.currentUrl == '/confirmation-account-verification' || this.currentUrl == '/success-account-verification'   || this.currentUrl == '/failed-account-verification' ){
      $('#beforeLoginbg').addClass('dark-bg')
    } else {
      $('#beforeLoginbg').removeClass('dark-bg')
    }
  }
  
  getAllMasterData(){
    const url = "/common-contents"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      localStorage.setItem('grw_version',response.version.master_version);
      if(response.success ==1) {  
        var self=this,ss:any=[],dd:any=[];       
        response.data.suitability.filter((el:any)=>{
          el.check = false;
        })
        response.data.race.filter((el:any)=>{
          if(el.name!='Other' && el.name!='other'){
            ss.push(el);
          } else {
            dd=el;
          }
          el.chcecked = false;
        })
        ss.push(dd);
        response.data.race =ss;
        ss=[],dd=[];
        response.data.expertise.filter((el:any)=>{
          if(el.childContent==false){
            ss.push(el);
          } else {
            dd=el;
          }
          el.chcecked = false;
        })
        ss.push(dd);
        response.data.expertise =ss;
        ss=[],dd=[];
        console.log(response.data.race)
        localStorage.setItem('grw_materData',JSON.stringify(response.data));
      }
    }), (error) => { this.loading =false; });
  }

}
